export const LOCAL_EXPORT_DOWNLOAD_PREFIX = '/__cpq-local-export';

const LOCAL_EXPORT_TICKET_PATH =
  /^\/local-export-artifacts\/[1-9][0-9]{0,18}\.[A-Za-z0-9_-]{1,512}$/;
const LOCAL_EXPORT_PROXY_PATH =
  /^\/__cpq-local-export\/local-export-artifacts\/[1-9][0-9]{0,18}\.[A-Za-z0-9_-]{1,512}$/;
const LEGACY_LOCAL_EXPORT_PROXY_PATH =
  /^\/__cpq-local-export\/local-export-artifacts\/[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/;
const LOCAL_HTTP_ORIGIN = /^http:\/\/127\.0\.0\.1:([0-9]{1,5})$/;
const LOCAL_HTTPS_ORIGIN = /^https:\/\/127\.0\.0\.1:([0-9]{1,5})$/;

/** Validate an explicitly configured loopback export origin without normalizing it. */
export function localExportOrigin(value?: string): string | null {
  if (!value) return null;
  const match = LOCAL_HTTP_ORIGIN.exec(value) ?? LOCAL_HTTPS_ORIGIN.exec(value);
  const port = Number(match?.[1]);
  if (!match || !Number.isInteger(port) || port < 1 || port > 65535)
    throw new Error('本地导出下载代理只允许带有效端口的 127.0.0.1 origin');
  const parsed = new URL(value);
  if (
    parsed.origin !== value ||
    parsed.username ||
    parsed.password ||
    parsed.pathname !== '/' ||
    parsed.search ||
    parsed.hash
  )
    throw new Error('本地导出下载代理只允许带有效端口的 127.0.0.1 origin');
  return value;
}

/** Vite middleware accepts only ticket GETs; the adapter performs HMAC/DB checks. */
export function localExportProxyRequestAllowed(
  requestUrl: string,
  method = 'GET',
  strictTicket = false,
): boolean {
  if (
    method !== 'GET' ||
    !requestUrl.startsWith('/') ||
    requestUrl.startsWith('//') ||
    requestUrl.includes('\\')
  )
    return false;
  let request: URL;
  try {
    request = new URL(requestUrl, 'http://127.0.0.1');
  } catch {
    return false;
  }
  return (
    !request.username &&
    !request.password &&
    !request.search &&
    !request.hash &&
    (strictTicket
      ? LOCAL_EXPORT_PROXY_PATH
      : LEGACY_LOCAL_EXPORT_PROXY_PATH
    ).test(request.pathname)
  );
}

/** Only the explicitly configured local acceptance endpoint may be proxied. */
export function exportDownloadRequestUrl(
  url: string,
  development: boolean,
  configuredOrigin?: string,
): string {
  const value = new URL(url);
  if (value.protocol === 'https:') {
    if (!development || value.hostname !== '127.0.0.1') return url;
    const origin = localExportOrigin(configuredOrigin);
    if (
      !origin?.startsWith('https://') ||
      value.origin !== origin ||
      value.username ||
      value.password ||
      value.search ||
      value.hash ||
      !LOCAL_EXPORT_TICKET_PATH.test(value.pathname)
    ) {
      throw new Error('导出下载地址无效');
    }
    return `${LOCAL_EXPORT_DOWNLOAD_PREFIX}${value.pathname}`;
  }

  if (
    !development ||
    !configuredOrigin ||
    localExportOrigin(configuredOrigin) !== configuredOrigin ||
    !configuredOrigin.startsWith('http://') ||
    value.origin !== configuredOrigin ||
    value.username ||
    value.password ||
    value.search ||
    value.hash ||
    !/^\/local-export-artifacts\/[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/.test(
      value.pathname,
    )
  ) {
    throw new Error('导出下载地址无效');
  }
  return `${LOCAL_EXPORT_DOWNLOAD_PREFIX}${value.pathname}`;
}
